import { Module } from "vuex";
import { IActions, IGetters, IMutations, IActionCustomerState } from "./activeCustomer.type";

export const getters: IGetters = {
    // getId: (state) => {
    //     return state.sale?.id;
    // },
};

export const mutations: IMutations = {
    // setLoading: (state, payload) => {
    //     state.loading = payload;
    // },
    setCustomer: (state, payload) => {
        state.customer = payload;
    },
    // setCustomers: (state, payload) => {
    //     // state.customers = payload;
    // }
};

export const actions: IActions = {
    // async fetchSale(this, context, payload): Promise<void> {
    //     const u = await this.$services.sales.getSaleById(payload);
    //     context.commit("setUser", u?.data());
    // },
    // async syncSale(this, context, payload): Promise<void> {
    //     console.log("syncSale:", payload);
    //     try {
    //         context.commit("setLoading", true);
    //         const u = await this.$services.sales.syncSale(payload);
    //         context.commit("setSale", u.data());
    //         console.log(u.customerList());
    //         context.commit("setCustomers", u.customerList());
    //     } catch (error) {
    //         console.warn(error);
    //     } finally {
    //         context.commit("setLoading", false);
    //     }
    // },
};

const activeCustomer: Module<IActionCustomerState, IActionCustomerState> = {
    namespaced: true,
    state: {
        customer: {
            address: []
        },
    },
    getters,
    mutations,
    actions,
};

export default activeCustomer;
